/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([]);